var gaProperty = '';
var disableStr = '';

document.addEventListener("DOMContentLoaded", function(event) {
	var el = document.querySelector('body');
	gaProperty = el.getAttribute('data-analyticscode');

	//  Tracking deaktivieren, wenn das Cookie gesetzt ist
	disableStr = 'ga-disable-' + gaProperty;
	if (document.cookie.indexOf(disableStr + '=true') > -1) {
		window[disableStr] = true;
	}
});

function gaOptout() {
	document.cookie = disableStr + '=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
	window[disableStr] = true;

	var dButton = document.getElementById('ttgAnalyticsDeactivate');
	var eButton = document.getElementById('ttgAnalyticsSuccess');

	showHide(dButton);
	showHide(eButton);
}

function showHide(e){
	if ( e.style.display != 'none' ) {
		e.style.display = 'none';
	}
	else {
		e.removeAttribute('style');
	}
}